import { createFileRoute } from "@tanstack/react-router";

import DiscoveryPage from "@/pages/DiscoveryPage";

export const Route = createFileRoute("/_app/(discovery)/discovery")({
  component: () => <DiscoveryPage />,
});
